// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="use-this-api-to-stay-up-to-date-on-va-forms.">Use this API to stay up to date on VA forms.</h2>
    </div>
  );
};

export default MarkdownComponent;
